import styled from 'styled-components';

export const MoreActionsMenuWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const MoreActionsMenuButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 11px;
  border: 2px solid #ff2d38;
  border-radius: 30px;
  background: #fff;
  cursor: pointer;
  line-height: 0;
  transition: background 0.15s;
  margin: 0 !important;

  img {
    width: 24px;
    height: 24px;
    display: block;
  }

  &:hover {
    background: #fdecee;
  }
`;

export const MoreActionsMenuList = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  background: #fff;
  box-shadow: 0px 5px 10px 0px #00000033;
  padding: 12px 8px;
  min-width: 240px;
  z-index: 1300;
`;

export const MoreActionsMenuItem = styled.button`
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  text-align: left;
  border: none;
  background: transparent;
  padding: 0 16px;
  font-size: 14px;
  font-weight: 500;
  color: #172751;
  cursor: pointer;

  &:hover {
    background: #f3f4f6;
  }
`;
